import fetchUserMetadata, {
    fetchScreensMetadata
} from 'src/components/user/user/api/user-api';
import axios from 'axios';
import Storage from 'src/utils/storage/storage';
import {
    SERVICE_URL,
    APP_CLIENT_ID,
    APP_CLIENT_SECRET,
    ENDPOINTS
} from '../../constants';

const client_id = APP_CLIENT_ID;
const client_secret = APP_CLIENT_SECRET;

export async function getAccessToken(setIsAuthenticated, setIsSigningIn) {
    // Validation: Check if required constants are present
    if (!SERVICE_URL) {
        console.error('SERVICE_URL is not defined');
    }
    if (!client_id) {
        console.error('APP_CLIENT_ID is not defined');
    }
    if (!client_secret) {
        console.error('APP_CLIENT_SECRET is not defined');
    }
    if (!ENDPOINTS.getToken || !ENDPOINTS.convertSocialToken) {
        console.error('ENDPOINTS.getToken or ENDPOINTS.convertSocialToken is not defined');
    }

    const config = {
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
        }
    };

    const username = localStorage.getItem('email');
    const password = localStorage.getItem('password');
    const signInType = localStorage.getItem('signin_type');
    const accessToken = localStorage.getItem('social_access_token');

    // Validation: Check if required localStorage values are present based on signin type
    if (signInType === 'email') {
        if (!username) {
            console.error('Email (username) is not available in localStorage for email sign-in');
        }
        if (!password) {
            console.error('Password is not available in localStorage for email sign-in');
        }
    } else if (signInType === 'microsoft' || signInType === 'google') {
        if (!accessToken) {
            console.error('Social access token is not available in localStorage for social sign-in');
        }
    }

    console.log('signin type', signInType);
    // if(accesstoken) body =
    const body =
        signInType == 'email'
            ? JSON.stringify({
                username,
                password,
                grant_type: 'password',
                client_id,
                client_secret
            })
            : JSON.stringify({
                token: accessToken,
                client_id,
                client_secret,
                backend:
                    signInType == 'microsoft'
                        ? 'azuread-tenant-oauth2'
                        : 'google-oauth2',
                grant_type: 'convert_token'
            });
    const loginUrl = `${SERVICE_URL}${signInType == 'email' ? ENDPOINTS.getToken : ENDPOINTS.convertSocialToken
        }`;

    try {
        const res = await axios.post(loginUrl, body, config);
        if (signInType == 'email') {
            localStorage.removeItem('email');
            localStorage.removeItem('password');
        }
        console.log('Login success.');
        localStorage.setItem('access', res.data.access_token);
        localStorage.setItem('refresh', res.data.refresh_token);
        let userMeta;
        // eslint-disable-next-line no-useless-catch
        try {
            userMeta = await fetchUserMetadata();
        } catch (e) {
            // returning error in case of anauthorized user
            throw e;
        }

        const screenMeta = await fetchScreensMetadata();
        Storage.setUserMetadata({
            userMeta: userMeta.data[0],
            screenMeta: screenMeta.data.results
        });
        localStorage.setItem('isAuthenticated', true);
        document.cookie = `X-Authorization=${res.data.access_token}; path=/`;
        setIsAuthenticated(true);
        localStorage.setItem('signing_in', false);
        setIsSigningIn(false);
    } catch (err) {
        console.log('this is login error', err);
        return err;
    }
}

export async function getNewAccessToken() {
    // Validation: Check if required constants are present
    if (!SERVICE_URL) {
        console.error('SERVICE_URL is not defined');
    }
    if (!client_id) {
        console.error('APP_CLIENT_ID is not defined');
    }
    if (!client_secret) {
        console.error('APP_CLIENT_SECRET is not defined');
    }
    if (!ENDPOINTS.refreshToken) {
        console.error('ENDPOINTS.refreshToken is not defined');
    }

    const unauthorizedCodes = [401, 500];
    const refreshToken = localStorage.getItem('refresh');

    // Validation: Check if refresh token is present
    if (!refreshToken) {
        console.error('No refresh token available in localStorage, redirecting user to login page');
        window.location.href = `${window.location.origin}/app/login`;
    }

    const config = {
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
        }
    };
    const body = JSON.stringify({
        refresh_token: refreshToken,
        client_id,
        client_secret,
        grant_type: 'refresh_token'
    });

    try {
        const res = await axios.post(
            `${SERVICE_URL}${ENDPOINTS.refreshToken}`,
            body,
            config
        );
        if (res.status == 200) {
            console.log('refresh token successful');
            localStorage.setItem('access', res.data.access_token);
            localStorage.setItem('refresh', res.data.refresh_token);
            localStorage.setItem('isAuthenticated', true);
            document.cookie = `X-Authorization=${res.data.access_token}; path=/`;
            localStorage.setItem('signing_in', false);
            location.reload();
            // setIsSigningIn(false)
        }
    } catch (err) {
        console.log('this is refresh api error', err.response);

        if (
            unauthorizedCodes.includes(err.response.status) ||
            err.response.data.error == 'invalid_grant' ||
            err.response == '401'
        ) {
            console.log('this is refresh api error', err.response.status);
            localStorage.clear();
            document.cookie =
                'X-Authorization=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
            window.location.href = `${window.location.origin}${ENDPOINTS.loginUrl}`;
        }
        // console.log("social access token is not yet available!! Will check again in 2 seconds.")
    }
}